/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="manufacturers.module.ts" />

module Meevo.Plugins.Manufacturers {
    class ManufacturersController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

      static $inject = ["meevo.AppSettings", "meevo.components.common.DataService",
        "meevo.components.modal.ModalService", "meevo.components.common.IdentityService",
        "meevo.components.logging.LoggingService", "meevo.components.common.SecurityService",
        "meevo.components.tracking.TrackingService",
        "$rootScope", "$scope", "$state", "meevo.ContextParams",
        'meevo.components.short-cuts.ShortCutsService',

        "meevo.components.busy.BusyService",
        "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected loggingService: Meevo.Components.Logging.ILoggingService,
          protected securityService: Meevo.Components.Common.ISecurityService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected $rootScope: angular.IRootScopeService,
          protected $scope: angular.IScope,
          protected $state: any,
          protected contextParams: any,
          protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

          protected busyService: Meevo.Components.Busy.IBusyService,
          protected $translate: angular.translate.ITranslateService) {

          super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_MANUFACTURER).then(() => {
                vm.busyService.stop();
                vm.context = new ManufacturersContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService);
                vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
                vm.context.deactivate = () => {
                    vm.visualState = Model.MaintenanceFormVisualState.Search;
                }
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                    ];
            }).catch(() => {
                this.busyService.stop();
            });
        }
  }


    angular.module("meevo.plugins.manufacturers")
        .controller("meevo.plugins.manufacturers.ManufacturersController", ManufacturersController);
}